<script>
  import { onMount } from "svelte";
  import SideBar from "../components/SideBar.svelte";
  import Dropdown from "sv-bootstrap-dropdown";

  let searchTerm = "";

  let dropdownTrigger;
  let userData = null;
  let sidebarVisible = false;

  function logout() {
    localStorage.removeItem("userData");
    userData = null;
    window.location.href = "#/login";
  }

  onMount(() => {
    userData = JSON.parse(localStorage.getItem("userData"));
  });

  function closeSidebar() {
    sidebarVisible = false;
  }

  function goToProfilePage() {
    window.location.href = "#/profile";
  }

  async function handleSearch() {
    if (searchTerm.trim() === "") return;

    const response = await fetch(
      `https://api.trulens.ae/api/videos/all-search?searchTerm=${encodeURIComponent(searchTerm)}`
    );
    const data = await response.json();

    if (response.ok) {
      localStorage.setItem("storedVideos", JSON.stringify(data));
      window.location.href = "#/results";
      window.location.reload();
    } else {
      console.error("Error fetching search results:", data.error);
    }
  }
</script>

<div class="content">
  <header>
    <div class="logo-menu">
      <!-- Menu icon -->
      <span
        class="menu-icon"
        style="cursor: pointer;"
        on:click={() => (sidebarVisible = !sidebarVisible)}>☰</span
      >

      <!-- Logo -->
      <a href="/">
        <img src="/PrimaryLogo.png" alt="TruLens" class="logo-img" />
      </a>
    </div>

    {#if sidebarVisible}
      <SideBar on:mouseleave={closeSidebar} />
    {/if}

    {#if userData}
      <div class="drp">
        <Dropdown triggerElement={dropdownTrigger}>
          <button type="button" bind:this={dropdownTrigger}>
            {userData.user.name}
          </button>
          <div slot="DropdownMenu">
            <button type="button" on:click={goToProfilePage}>Profile</button>
            <button on:click={logout} style="background-color: #FF3C82;"
              >Logout</button
            >
          </div>
        </Dropdown>
      </div>
    {:else}
      <a href="#/login" style="text-decoration: none;">
        <div class="profile-btn">
          <span style="color: #FF3C82;">Log</span><span style="color: #1E92FF;"
            >in!</span
          >
        </div>
      </a>
    {/if}
  </header>
</div>

<style>
  header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 8vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    /* background: linear-gradient(90deg, #c7c7c7, #c7c7c7); */
    background: white;
    color: #000000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
    z-index: 1000;
  }

  .content {
    padding-top: 60px;
  }

  .logo {
    margin-left: 20px;
    font-size: 2rem;
    font-weight: bold;
    color: #1e92ff;
  }
  .logo a {
    text-decoration: none;
  }

  .search-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .search-input {
    position: relative; /* Ensure the button is positioned relative to the input */
    display: flex;
    align-items: center;
  }

  .search-input input {
    padding: 8px;
    font-size: 1rem;
    border: 1px solid #ffafcc;
    border-radius: 4px 0 0 4px; /* Rounded corners for left side */
  }

  .search-input button {
    padding: 8px 12px;
    font-size: 1rem;
    background-color: #ff3c82;
    color: white;
    border: none;
    border-radius: 0 4px 4px 0; /* Rounded corners for right side */
    cursor: pointer;
  }

  .search-input button:hover {
    background-color: #b683d4;
  }

  .profile-btn {
    cursor: pointer;
    font-size: 1.3rem;
    padding: 8px 12px;
    border-radius: 50%;
    font-weight: bold;

    display: flex;
    align-items: center;
    margin-right: 20px;
  }

  .drp {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }

  .drp button {
    width: 200px;
    cursor: pointer;
    padding: 8px 12px;
    background-color: #3498db;
    color: #ffffff;
    border: none;
    display: block;
    margin-bottom: 0;
    margin-top: 0;
  }

  .drp button:hover {
    background-color: #2980b9;
  }

  .logo-menu {
    display: flex;
    align-items: center;
  }

  .menu-icon {
    font-size: 2rem;
    margin-right: 10px;
    font-weight: bold;
    color: #1e92ff;
  }

  .logo-img {
    width: 150px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 768px) {
    header {
      height: 6vh;
    }

    .logo {
      margin-left: 10px;
      font-size: 0.8rem;
      font-weight: bold;
      color: #1e92ff;
    }

    .menu-icon {
      font-size: 1rem;
    }

    .logo-img {
      width: 80px;
    }

    .search-container {
      margin-top: 5px;
    }

    .search-container input {
      padding: 4px;
      font-size: 0.5rem;
    }

    .search-input button {
      padding: 4px 8px;
      font-size: 0.5rem;
    }

    .drp {
      margin-right: 20px;
    }

    .drp button {
      width: 80px;
      font-size: 0.5rem;
      padding: 4px 8px;
      cursor: pointer;
      background-color: #3498db;
      color: #ffffff;
      border: none;
      display: block;
      margin-right: 5px;
      
    }

    .profile-btn {
      font-size: 0.8rem;
      
    }
  }
</style>
